import { makeAutoObservable, runInAction } from 'mobx'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { demo } from 'page/catalog/store/CatalogStore'
import { api } from 'store/api'
import { Client, ClientSuggestRequest, loadRecentCustomers } from 'type/client'
import { validateEmail } from 'util/form'
import { normalizePhone } from 'util/phone'
import { delay } from 'util/promise'

type State = 'none' | 'short' | 'invalid' | 'busy' | 'success'

export class SearchStore {
  private sequence = 0
  private version = 0
  private company: string

  readonly min = 4

  state: State = 'none'
  text: string = ''
  clients: Client[] = []

  constructor(company: string) {
    this.company = company
    const recent = loadRecentCustomers(company, employee.manager_id)
    this.clients = recent.slice(0, 3)
    const empty = this.clients.length === 0
    this.state = empty ? 'none' : 'success'
    makeAutoObservable(this)
  }

  get phone(): string {
    return normalizePhone(this.text)
  }

  get email(): string {
    return this.text.replaceAll(/\s+/g, '')
  }

  get card(): string {
    return this.text.replaceAll(/\s+/g, '')
  }

  change(text: string | null | undefined) {
    const be = demo.it.by_email
    const bc = demo.it.by_card
    text = text || ''
    if (be) {
      text = text.replaceAll(/\s/g, '')
    } else if (bc) {
      text = text.replaceAll(/\s/g, '')
    } else {
      text = text.replaceAll(/[^\s\d+-]/g, '')
    }
    if (this.text === text) return

    this.text = text
    this.update(1000)
  }

  enter() {
    if (this.version < this.sequence) this.update()
  }

  private async update(ms?: number) {
    const be = demo.it.by_email
    const bc = demo.it.by_card
    const v = ++this.sequence
    const { company, phone, email, card } = this

    this.clients = []
    this.state = 'none'

    if (ms) await delay(ms)
    if (v !== this.sequence) return

    let request: ClientSuggestRequest
    if (be) {
      request = { company, email }
      if (!validateEmail(email)) {
        return runInAction(() => this.state = 'invalid')
      }
    } else if (bc) {
      request = { company, card }
      if (card.length < this.min) {
        return runInAction(() => {
          if (card.length > 0) this.state = 'short'
          else this.state = 'none'
        })
      }
    } else {
      request = { company, phone }
      if (phone.length < this.min) {
        return runInAction(() => {
          if (phone.length > 0) this.state = 'short'
          else this.state = 'none'
        })
      }
    }

    runInAction(() => {
      this.version = v
      this.state = 'busy'
    })

    const clients = await api.findClients(request)
    if (v !== this.sequence) return

    runInAction(() => {
      this.state = 'success'
      this.clients = clients
    })
  }
}
